const translations = {
  "he":  {
    "TITLE": "למה אני אשאר בבית?",
    "TITLE_QUESTION": "מה אתם מתכוונים לעשות בשבועות הקרובים?",
    "BTN_R0_LOW": "להישאר<br/>בבית",
    "BTN_R0_MEDIUM": "לבקר<br/>חברים",
    "BTN_R0_HIGH": "להמשיך<br/>בשגרה",
    "DEATH_COUNT": "מתים",
    "INFECTED_COUNT": "חולים",
    "INFECTED_COUNT_MAX": "חולים",
    "POPULATION_EXPOSED": "מהציבור חשוף לקורונה (COVID-19)",
    "PLAY": "גלו איך תתפשט המגפה",
    "Skip": "קדימה ",
    "Days": "ימים",
    "Stop": "עצור",
    "Play": "התחל",
    "Pause": "השהה",
    "skip_week": "שבוע",
    "Reset": "איפוס",
    "Date": "תאריך",
    "CREDIT": "פותח על ידי",
    "SOURCES": "מקורות:",
    "Share": "שתפו",
    "p1": "מה יקרה אם כולנו נישמע להנחיות הסגר, ומה יקרה אם נמשיך בשגרה? הסימולטור שלפניכם מאפשר לחקור את התרחישים האפשריים, בהתאם להתנהגות הציבור. הנתונים ההתחלתיים הם נתוני אמת ומעודכנים ליממה האחרונה.",
    "p2": "ניתן לשחק עם הגדרות נוספות בסימולטור ולבדוק איך הן משפיעות על התרחישים האפשריים. לדוגמה, אם אתם מניחים שרוב הנדבקים עוד לא נבדקו ולא אובחנו, אפשר להגדיר שמספר החולים האמיתי הוא פי 10 מכפי שדווח - ואז לראות מה קורה. הציצו בהגדרות המתקדמות כאן: ",
    "p3": "הסימולטור מבוסס על מודל SIR שמאפשר לחזות את שיעור התחלואה באוכלוסייה לפי קצב ההדבקה בנגיף הקורונה וקצב ההחלמה מהמחלה. זהו מודל בסיסי מאוד ומופשט מאוד, שמטרתו בסימולטור היא להמחיש את הקשר בין שיעור החשופים לנגיף באוכלוסייה לבין מספרי החולים והמתים. כל יום במודל מחושב לפי נתוני היום שלפניו, וההנחה הבסיסית היא שכל המשתנים קבועים לאורך כל תקופת התחזית - כלומר, אם 30% מהאוכלוסייה חשופים לנגיף ביום הראשון, אז זהו שיעור החשיפה לאורך התקופה כולה.",
    "p4": "נתוני האמת נשאבים אוטומטית מהמאגר של אוניברסיטת ג׳ונס הופקינס, שמתעדכן כמה פעמים ביום. ייתכנו עיכובים קלים בעדכון הנתונים.",
    "EDIT_MODEL": "הגדרות מתקדמות",
    "HIDE_SIDEBAR": "חזרה",
    "EDIT_MODEL_DESC": "ערכי ברירת המחדל מבוססים על הערכות לגבי נגיף הקורונה (COVID-19)",
    "last_data_update": "הנתונים מעודכנים לתאריך:",
    "Israel": "ישראל",
    "date": "תאריך",
    "confirmed": "חולים (מאובחנים)",
    "deaths": "מתים",
    "recovered": "החלימו",
    "HIDE_SIDEBAR_ALT": "הסתר הגדרות",
    "country": "מדינה",
    "rMeasureError": "היחס בין מספר החולים האמיתי לאלה שאובחנו",
    "rMeasureError_desc": "בסימולטור מוצג מספר החולים המאובחנים, בעוד שסביר שמספרם באוכלוסייה גבוה יותר ",
    "capacity": "קיבולת אשפוז",
    "capacity_desc": "אחוז מהאוכלוסייה אותה ניתן לאשפז בכל נקודת זמן.",
    "rSevereCases": "שיעור החולים הזקוקים לאשפוז",
    "rSevereCases_desc": "נתון זה יכול להשפיע על שיעור התמותה כאשר בתי החולים בתפוסה מלאה",
    "rOverCapacityDeaths_desc": "שיעור תמותה כאשר בתי החולים בתפוסה מלאה",
    "rOverCapacityDeaths": "שיעור תמותה בתפוסה מלאה",
    "rDeath": "שיעור תמותה מהמחלה",
    "rDeath_desc": "אחוז החולים שימותו",
    "rRecoveryDays": "תקופת הדבקה ממוצעת (ימים)",
    "rRecoveryDays_desc": "מספר הימים בו חולה יכול להדביק אחרים",
    "rInfectionRate": "קצב הדבקה",
    "rInfectionRate_desc": "כמה אנשים מדביק אדם אחד ביום",
    "daysCount": "מספר ימים",
    "daysCount_desc": "כמה ימים להריץ במודל",
    "rSusceptible": "שיעור חשיפה",
    "rSusceptible_desc": "שיעור האוכלוסייה החשופה לנגיף. ערך זה יהיה קטן יותר כאשר אנחנו מאמצים התנהגות של בידוד חברתי.",
    "slider_instructions": "הזיזו את הסרגל כדי להתחיל",
    "POPULATION_EXPOSED_PRE": "מה עשוי לקרות אם ",
    "POPULATION_EXPOSED_POST": "מהציבור יהיה חשוף לקורונה (Covid 19) בשבועות הקרובים",
    "Afghanistan": "אפגניסטן",
    "Albania": "אלבניה",
    "Algeria": "אלג׳יר ",
    "Andorra": "אנדורה",
    "Angola": "אנגולה",
    "Antigua and Barbuda": "אנטיגואה וברבודה",
    "Argentina": "ארגנטינה",
    "Armenia": "ארמניה",
    "Austria": "אוסטריה",
    "Azerbaijan": "אזרבייג'ן",
    "Bahamas": "איי בהאמה",
    "Bahrain": "בחריין",
    "Bangladesh": "בנגלדש",
    "Barbados": "ברבדוס",
    "Belarus": "בלארוס",
    "Belgium": "בלגיה",
    "Belize": "בליז",
    "Benin": "בנין",
    "Bhutan": "בהוטן",
    "Bolivia": "בוליביה",
    "Bosnia and Herzegovina": "בוסניה והרצגובינה",
    "Botswana": "בוצואנה",
    "Brazil": "ברזיל",
    "Brunei": "ברוניי",
    "Bulgaria": "בולגריה",
    "Burkina Faso": "בורקינה פאסו",
    "Burma": "בורמה",
    "Burundi": "בורונדי",
    "Cabo Verde": "קאבו ורדה",
    "Cambodia": "קמבודיה",
    "Cameroon": "קמרון",
    "Central African Republic": "הרפובליקה המרכז - אפריקאית",
    "Chad": "צ'אד",
    "Chile": "צ'ילה",
    "Colombia": "קולומביה",
    "Congo (Brazzaville)": "קונגו (ברזוויל)",
    "Congo (Kinshasa)": "קונגו (קינשאסה)",
    "Costa Rica": "קוסטה ריקה",
    "Cote d'Ivoire": "חוף השנהב",
    "Croatia": "קרואטיה",
    "Cuba": "קובה",
    "Cyprus": "קפריסין",
    "Czechia": "צ'כיה",
    "Denmark": "דנמרק",
    "Diamond Princess": "ספינת הנופש דיאמונד פרינסס",
    "Djibouti": "ג'יבוטי",
    "Dominica": "דומיניקה",
    "Dominican Republic": "הרפובליקה הדומיניקנית",
    "Ecuador": "אקוודור",
    "Egypt": "מצרים",
    "El Salvador": "אל סלבדור",
    "Equatorial Guinea": "גיניאה המשוונית",
    "Eritrea": "אריתריאה",
    "Estonia": "אסטוניה",
    "Eswatini": "אסווטיני (סוואזילנד)",
    "Ethiopia": "אתיופיה",
    "Fiji": "פיג'י",
    "Finland": "פינלנד",
    "France": "צרפת",
    "Gabon": "גבון",
    "Gambia": "גמביה",
    "Georgia": "גיאורגיה",
    "Germany": "גרמניה",
    "Ghana": "גאנה",
    "Greece": "יוון",
    "Grenada": "גרנדה",
    "Guatemala": "גואטמלה",
    "Guinea": "גינאה",
    "Guinea-Bissau": "גינאה ביסאו",
    "Guyana": "גיאנה",
    "Haiti": "האיטי",
    "Holy See": "הוותיקן ",
    "Honduras": "הונדורס",
    "Hungary": "הונגריה",
    "Iceland": "איסלנד",
    "India": "הודו",
    "Indonesia": "אינדונזיה",
    "Iran": "איראן",
    "Iraq": "עירק",
    "Ireland": "אירלנד",
    "Israel": "ישראל",
    "Italy": "איטליה",
    "Jamaica": "ג'מייקה",
    "Japan": "יפן",
    "Jordan": "ירדן",
    "Kazakhstan": "קזחסטן",
    "Kenya": "קניה",
    "Korea, South": "דרום קוריאה",
    "Kosovo": "קוסובו",
    "Kuwait": "כווית",
    "Kyrgyzstan": "קירגיזסטן",
    "Laos": "לאוס",
    "Latvia": "לטביה",
    "Lebanon": "לבנון",
    "Liberia": "ליבריה",
    "Libya": "לוב",
    "Liechtenstein": "ליכטנשטיין",
    "Lithuania": "ליטא",
    "Luxembourg": "לוקסמבורג",
    "Madagascar": "מדגסקר",
    "Malawi": "מלאווי",
    "Malaysia": "מלזיה",
    "Maldives": "האיים המלדיביים",
    "Mali": "מאלי ",
    "Malta": "מלטה",
    "Mauritania": "מאוריטניה",
    "Mauritius": "מאוריציוס",
    "Mexico": "מקסיקו",
    "Moldova": "מולדובה",
    "Monaco": "מונקו",
    "Mongolia": "מונגוליה",
    "Montenegro": "מונטנגרו",
    "Morocco": "מרוקו",
    "Mozambique": "מוזמביק",
    "MS Zaandam": "ספינת הנופש זאנדאם",
    "Namibia": "נמיביה",
    "Nepal": "נפאל",
    "Netherlands": "הולנד",
    "New Zealand": "ניו זילנד",
    "Nicaragua": "ניקרגואה",
    "Niger": "ניז'ר",
    "Nigeria": "ניגריה",
    "North Macedonia": "צפון מקדוניה",
    "Norway": "נורווגיה",
    "Oman": "עומאן",
    "Pakistan": "פקיסטן",
    "Panama": "פנמה",
    "Papua New Guinea": "פפואה גינאה החדשה",
    "Paraguay": "פרגוואי",
    "Peru": "פרו",
    "Philippines": "הפיליפינים",
    "Poland": "פולין",
    "Portugal": "פורטוגל",
    "Qatar": "קטאר",
    "Romania": "רומניה",
    "Russia": "רוסיה",
    "Rwanda": "רואנדה",
    "Saint Kitts and Nevis": "סנט קיטס ונוויס",
    "Saint Lucia": "סנט לוסיה",
    "Saint Vincent and the Grenadines": "סנט וינסנט והגרנדינים",
    "San Marino": "סן מרינו",
    "Sao Tome and Principe": "סאו טומה ופרינסיפה",
    "Saudi Arabia": "סעודיה ",
    "Senegal": "סנגל",
    "Serbia": "סרביה",
    "Seychelles": "איי סיישל ",
    "Sierra Leone": "סיירה לאון",
    "Singapore": "סינגפור",
    "Slovakia": "סלובקיה",
    "Slovenia": "סלובניה",
    "Somalia": "סומליה",
    "South Africa": "דרום אפריקה",
    "South Sudan": "דרום סודן",
    "Spain": "ספרד",
    "Sri Lanka": "סרי לנקה",
    "Sudan": "סודן",
    "Suriname": "סורינאם",
    "Sweden": "שבדיה",
    "Switzerland": "שוויץ",
    "Syria": "סוריה",
    "Taiwan*": "טייוואן",
    "Tanzania": "טנזניה",
    "Thailand": "תאילנד",
    "Timor-Leste": "מזרח טימור",
    "Togo": "טוגו ",
    "Trinidad and Tobago": "טרינידד וטובגו",
    "Tunisia": "תוניסיה",
    "Turkey": "טורקיה",
    "Uganda": "אוגנדה",
    "Ukraine": "אוקראינה",
    "United Arab Emirates": "איחוד האמירויות הערביות",
    "United Kingdom": "בריטניה",
    "Uruguay": "אורוגוואי",
    "Uzbekistan": "אוזבקיסטן",
    "Venezuela": "ונצואלה",
    "Vietnam": "וייטנאם",
    "West Bank and Gaza": "הגדה המערבית ועזה",
    "Western Sahara": "סהרה המערבית",
    "Yemen": "תימן",
    "Zambia": "זמביה",
    "Zimbabwe": "זימבבואה",
    "Australia": "אוסטרליה",
    "Canada": "קנדה",
    "China": "סין",
    "US": "ארה\"ב"
  }
}

var currLang = "he";

class translation {
  
  static setLanguage(lang) {
    currLang = lang;
  }

  static getLanguage() {
    return currLang;
  }

  static t(id) {
    return translations[currLang][id] || id;
  }
}

export default translation